<!-- SkyPlus Contracts Dashboard with Bulk Selection -->
<div class="sp-dashboard-container">
  <!-- HEADER -->
  <sp-header></sp-header>

  <!-- MAIN CONTENT -->
  <main class="sp-main">
    <!-- Page Header -->
    <div class="sp-page-header">
      <div class="sp-greeting">
        <h1><span class="material-icons page-icon">description</span> Contract Management</h1>
        <p>Manage contracts, agreements and renewals</p>
      </div>
      <div class="sp-header-actions">
        <button class="btn btn-outline" (click)="refreshContracts()">
          <span class="material-icons">refresh</span> Refresh
        </button>
        <button class="btn btn-outline" (click)="exportContracts()">
          <span class="material-icons">download</span> Export
        </button>
        <button class="btn btn-outline" (click)="uploadExecutedContract()">
          <span class="material-icons">upload_file</span> Upload Executed Contract
        </button>
        <button class="btn btn-primary" (click)="createContract()">
          <span class="material-icons">add</span> New Contract
        </button>
      </div>
    </div>

    <!-- Stats Cards -->
    <section class="sp-stats-section">
      <div class="sp-stat-card clickable" [class.selected]="selectedStatus === 'all'" (click)="setStatusFilter('all')">
        <div class="sp-stat-icon total"><span class="material-icons">folder</span></div>
        <div class="sp-stat-content">
          <div class="sp-stat-value">{{ stats.total }}</div>
          <div class="sp-stat-label">Total Contracts</div>
        </div>
      </div>

      <div class="sp-stat-card clickable" [class.selected]="selectedStatus === 'Active'" (click)="setStatusFilter('Active')">
        <div class="sp-stat-icon active"><span class="material-icons">check_circle</span></div>
        <div class="sp-stat-content">
          <div class="sp-stat-value">{{ stats.active }}</div>
          <div class="sp-stat-label">Active</div>
        </div>
      </div>

      <div class="sp-stat-card clickable" [class.selected]="selectedStatus === 'Expiring Soon'" (click)="setStatusFilter('Expiring Soon')">
        <div class="sp-stat-icon warning"><span class="material-icons">schedule</span></div>
        <div class="sp-stat-content">
          <div class="sp-stat-value">{{ stats.expiringSoon }}</div>
          <div class="sp-stat-label">Expiring Soon</div>
        </div>
      </div>

      <div class="sp-stat-card clickable" [class.selected]="selectedStatus === 'Expired'" (click)="setStatusFilter('Expired')">
        <div class="sp-stat-icon expired"><span class="material-icons">error</span></div>
        <div class="sp-stat-content">
          <div class="sp-stat-value">{{ stats.expired }}</div>
          <div class="sp-stat-label">Expired</div>
        </div>
      </div>

      <div class="sp-stat-card clickable" [class.selected]="selectedStatus === 'Draft'" (click)="setStatusFilter('Draft')">
        <div class="sp-stat-icon pending"><span class="material-icons">edit_note</span></div>
        <div class="sp-stat-content">
          <div class="sp-stat-value">{{ stats.draft }}</div>
          <div class="sp-stat-label">Draft</div>
        </div>
      </div>

      <div class="sp-stat-card clickable" [class.selected]="selectedStatus === 'Pending Review'" (click)="setStatusFilter('Pending Review')">
        <div class="sp-stat-icon review"><span class="material-icons">rate_review</span></div>
        <div class="sp-stat-content">
          <div class="sp-stat-value">{{ stats.pendingReview }}</div>
          <div class="sp-stat-label">Pending Review</div>
        </div>
      </div>

    </section>

    <!-- Filters & Search -->
    <section class="filters-section">
      <div class="search-box">
        <span class="material-icons">search</span>
        <input type="text" 
               placeholder="Search contracts by title, number, or supplier..."
               [(ngModel)]="searchTerm"
               (input)="onSearch()">
        <button *ngIf="searchTerm" class="clear-btn" (click)="clearSearch()">
          <span class="material-icons">close</span>
        </button>
      </div>
      
      <div class="filter-group">
        <select [(ngModel)]="selectedStatus" (change)="onFilterChange()">
          <option value="all">All Status</option>
          <option value="Active">Active</option>
          <option value="Draft">Draft</option>
          <option value="Pending Review">Pending Review</option>
          <option value="Expiring Soon">Expiring Soon</option>
          <option value="Expired">Expired</option>
        </select>
        
        <select [(ngModel)]="selectedType" (change)="onFilterChange()">
          <option value="all">All Types</option>
          <option value="Lease">Lease</option>
          <option value="Service">Service</option>
          <option value="Purchase Order">Purchase Order</option>
          <option value="NDA">NDA</option>
          <option value="Employment">Employment</option>
          <option value="Other">Other</option>
        </select>
        
        <select [(ngModel)]="selectedDepartment" (change)="onFilterChange()">
          <option value="all">All Departments</option>
          <option *ngFor="let dept of departments" [value]="dept">{{ dept }}</option>
        </select>
      </div>
    </section>

    <!-- Bulk Actions Bar (appears when items selected) -->
    <section class="bulk-actions-bar" *ngIf="selectedContracts.size > 0">
      <div class="selection-info">
        <span class="material-icons">check_circle</span>
        <span>{{ selectedContracts.size }} contract{{ selectedContracts.size > 1 ? 's' : '' }} selected</span>
      </div>
      <div class="bulk-buttons">
        <button class="btn btn-outline" (click)="clearSelection()">
          <span class="material-icons">close</span> Clear Selection
        </button>
        <button class="btn btn-danger" (click)="deleteSelectedContracts()">
          <span class="material-icons">delete</span> Delete Selected
        </button>
      </div>
    </section>

    <!-- Loading State -->
    <div class="sp-loading" *ngIf="isLoading">
      <span class="material-icons spinning">autorenew</span>
      <p>Loading contracts...</p>
    </div>

    <!-- Contracts Table -->
    <section class="contracts-table-section" *ngIf="!isLoading">
      <div class="table-container">
        <table class="contracts-table">
          <thead>
            <tr>
              <th class="checkbox-col">
                <label class="checkbox-wrapper">
                  <input type="checkbox" 
                         [checked]="isAllSelected()" 
                         [indeterminate]="isSomeSelected()"
                         (change)="toggleSelectAll($event)">
                  <span class="checkmark"></span>
                </label>
              </th>
              <th class="sortable" (click)="toggleSort('contractNumber')">
                Contract No.
                <span class="material-icons sort-icon" *ngIf="sortBy === 'contractNumber'">
                  {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </th>
              <th class="sortable" (click)="toggleSort('contractTitle')">
                Title
                <span class="material-icons sort-icon" *ngIf="sortBy === 'contractTitle'">
                  {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </th>
              <th>Type</th>
              <th>Supplier</th>
              <th>Department</th>
              <th class="sortable text-right" (click)="toggleSort('contractAmount')">
                Value
                <span class="material-icons sort-icon" *ngIf="sortBy === 'contractAmount'">
                  {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </th>
              <th class="sortable" (click)="toggleSort('expiryDate')">
                Expiry
                <span class="material-icons sort-icon" *ngIf="sortBy === 'expiryDate'">
                  {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </th>
              <th>Days Left</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let contract of paginatedContracts" 
                [class.expired]="contract.contractStatus === 'Expired'"
                [class.expiring]="contract.contractStatus === 'Expiring Soon'"
                [class.selected]="isSelected(contract)"
                (click)="viewContract(contract)">
              <td class="checkbox-col" (click)="$event.stopPropagation()">
                <label class="checkbox-wrapper">
                  <input type="checkbox" 
                         [checked]="isSelected(contract)"
                         (change)="toggleSelection(contract, $event)">
                  <span class="checkmark"></span>
                </label>
              </td>
              <td class="contract-number-cell">
                <span class="contract-number" *ngIf="contract.contractNumber">{{ contract.contractNumber }}</span>
                <span class="no-data" *ngIf="!contract.contractNumber">-</span>
              </td>
              <td class="contract-title-cell">
                <span class="contract-title">{{ contract.contractTitle || contract.name }}</span>
              </td>
              <td>
                <span class="contract-type badge-type" [attr.data-type]="contract.contractType">
                  {{ contract.contractType || 'Other' }}
                </span>
              </td>
              <td>
                <span class="supplier-name" *ngIf="contract.supplierName">{{ contract.supplierName }}</span>
                <span class="no-data" *ngIf="!contract.supplierName">-</span>
              </td>
              <td>
                <span class="department-name" *ngIf="contract.departmentName">{{ contract.departmentName }}</span>
                <span class="no-data" *ngIf="!contract.departmentName">-</span>
              </td>
              <td class="text-right">
                <span class="contract-value" *ngIf="contract.contractAmount > 0">
                  {{ formatCurrency(contract.contractAmount, contract.currency) }}
                </span>
                <span class="no-data" *ngIf="!contract.contractAmount || contract.contractAmount === 0">-</span>
              </td>
              <td>
                <span class="expiry-date" *ngIf="contract.expiryDate">{{ formatDate(contract.expiryDate) }}</span>
                <span class="no-data" *ngIf="!contract.expiryDate">-</span>
              </td>
              <td>
                <span class="days-remaining" [ngClass]="getDaysClass(contract.daysToExpiry)" *ngIf="contract.daysToExpiry !== null">
                  <ng-container *ngIf="contract.daysToExpiry < 0">
                    {{ Math.abs(contract.daysToExpiry) }}d overdue
                  </ng-container>
                  <ng-container *ngIf="contract.daysToExpiry === 0">
                    Today
                  </ng-container>
                  <ng-container *ngIf="contract.daysToExpiry > 0">
                    {{ contract.daysToExpiry }}d
                  </ng-container>
                </span>
                <span class="no-data" *ngIf="contract.daysToExpiry === null">-</span>
              </td>
              <td>
                <span class="status-badge" [ngClass]="getStatusClass(contract.contractStatus)">
                  {{ contract.contractStatus }}
                </span>
              </td>
              <td class="actions-cell" (click)="$event.stopPropagation()">
                <button class="btn-icon" title="View" (click)="viewContract(contract)">
                  <span class="material-icons">visibility</span>
                </button>
                <button class="btn-icon" title="Edit" (click)="editContract(contract)">
                  <span class="material-icons">edit</span>
                </button>
                <button class="btn-icon delete" title="Delete" (click)="deleteContract(contract)">
                  <span class="material-icons">delete</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Empty State -->
        <div class="sp-empty-state" *ngIf="filteredContracts.length === 0">
          <span class="material-icons">folder_off</span>
          <h3>No contracts found</h3>
          <p *ngIf="hasFiltersApplied()">Try adjusting your filters or search term</p>
          <p *ngIf="!hasFiltersApplied()">Get started by creating your first contract</p>
          <button class="btn btn-primary" (click)="createContract()">
            <span class="material-icons">add</span> Create Contract
          </button>
        </div>
      </div>

      <!-- Pagination -->
      <div class="pagination-container" *ngIf="filteredContracts.length > 0">
        <div class="pagination-info">
          Showing {{ paginationStart + 1 }} - {{ paginationEnd }} of {{ filteredContracts.length }} contracts
        </div>
        
        <div class="pagination-controls">
          <select [(ngModel)]="pageSize" (change)="onPageSizeChange()" class="page-size-select">
            <option [value]="10">10 per page</option>
            <option [value]="25">25 per page</option>
            <option [value]="50">50 per page</option>
            <option [value]="100">100 per page</option>
          </select>
          
          <div class="pagination-buttons">
            <button class="btn-page" [disabled]="currentPage === 1" (click)="goToPage(1)" title="First">
              <span class="material-icons">first_page</span>
            </button>
            <button class="btn-page" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)" title="Previous">
              <span class="material-icons">chevron_left</span>
            </button>
            
            <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
            
            <button class="btn-page" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)" title="Next">
              <span class="material-icons">chevron_right</span>
            </button>
            <button class="btn-page" [disabled]="currentPage === totalPages" (click)="goToPage(totalPages)" title="Last">
              <span class="material-icons">last_page</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  </main>
</div>